import Button from '@jetbrains/ring-ui/components/button/button'
import {Caption} from '@jetbrains/ring-ui/components/button-group/button-group'
import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import type {ListDataItem} from '@jetbrains/ring-ui/components/list/consts'
import PopupMenu from '@jetbrains/ring-ui/components/popup-menu/popup-menu'
import classNames from 'classnames'
import * as React from 'react'

import type {FilterPersonalForm} from '../../Rules.types'
import {FilterPersonal} from '../../Rules.types'
import {LoadingContext, DispatchContext} from '../CleanupForm.contexts'
import styles from '../CleanupForm.css'

type PersonalItem = {
  name: FilterPersonal
  label: string
}

const defaultPersonalItem = {
  name: FilterPersonal.ANY,
  label: 'Personal and not personal',
} as const

const personalItems: ReadonlyArray<PersonalItem> = [
  defaultPersonalItem,
  {
    name: FilterPersonal.PERSONAL,
    label: 'Personal',
  },
  {
    name: FilterPersonal.NOT_PERSONAL,
    label: 'Not personal',
  },
]

type OwnProps = {
  value: FilterPersonal | null | undefined
}
export const personalConverter = {
  toForm: (value: FilterPersonalForm | null | undefined): FilterPersonal | null | undefined =>
    value?.personal ?? null,
  toRule: (value: FilterPersonal | null | undefined): FilterPersonalForm | null | undefined =>
    value != null && value !== defaultPersonalItem.name
      ? {
          personal: value,
        }
      : null,
}

function PersonalSection({value}: OwnProps) {
  const disabled = React.useContext(LoadingContext)
  const setValue = React.useContext(DispatchContext)
  const onChange = React.useCallback(
    (values: FilterPersonal) =>
      setValue?.({
        name: 'personal',
        value: values,
      }),
    [setValue],
  )
  const handleSelect = React.useCallback(
    (option: ListDataItem<{name: FilterPersonal}>) => onChange(option.name),
    [onChange],
  )
  const selectedItem = React.useMemo(
    () => personalItems.find(item => item.name === value) ?? defaultPersonalItem,
    [value],
  )
  return (
    <div className={styles.row}>
      <Caption className={styles.caption}>{'Personal'}</Caption>
      <div className={styles.content}>
        <div className={classNames(styles.inputs)}>
          <Dropdown
            anchor={
              <Button disabled={disabled} dropdown text className={styles.textButton}>
                {selectedItem.label}
              </Button>
            }
          >
            <PopupMenu onSelect={handleSelect} closeOnSelect data={personalItems} />
          </Dropdown>
        </div>
      </div>
    </div>
  )
}

export default React.memo<OwnProps>(PersonalSection)
